import { PlecaMorada } from "../../../utilities/PlecaMorada";
import Introduccion from "./introduccion";
import Recuadros from "./recuadros";

export default function Main(){
    window.scrollTo(0, 0)
    localStorage.setItem("seccion",'Autorías /')
    return(
        <>
            <Introduccion/>
            <div className="container mt-4">
                <div className="row">
                    <div className="col-12 mt-3">
                        <div className="row row justify-content-center">
                            <Recuadros/>
                        </div>
                    </div>
                </div>
            </div>
            <PlecaMorada/>
        </>
    )
}
